/**
 * Converts given minutes to hours.
 */
const minutesToHours = (minutes) => minutes ? (minutes/60) : null;  

/**
 * Converts given hours to minutes.
 */
const hoursToMinutes = (hours) => hours ? (hours*60) : null;

/**
 * Converts given minutes to exact hours and minutes. 
 */
const minutesToHourAndMinutes = (minutes) => {
	if(minutes) {
		const h = Math.floor(minutesToHours(minutes));
		const  m = minutes % 60;
		return { hours: h, minutes: m};
	}
	return {hours: null, minutes: null};
};

/**
 * returns an array of numbers 
 */
const getMinutes = (len) => [
	{value:0, label:"0"},
	{value:10, label:"10"},
	{value:20, label:"20"},
	{value:30, label:"30"},
	{value:40, label:"40"},
	{value:50, label:"50"},
];

/**
 * Handle errors while parsing json
 */
const parseToJson = (obj) => {
	try {
		return JSON.parse(obj);
	} catch(e) {
		console.error("Error while parsing data. ",e);
		return {};		 
	}
};

/**
 * Loads user role. Return id of given role
 */
const loadUserRole = (roles) => roles && Array.isArray(roles) && roles[0] ? roles[0].id : null;

/**
 * Loads extra permissions that user have.
 */
const loadUserPermissions = (user) => user && user.permissions;
 
/**
 * Loads permissions from from a specific for all user roles
 */
const loadRolePermissions = (roles) => {
	if(roles && Array.isArray(roles)) {
		const permissionsArray = [];
		for(let i=0; i<roles.length; i+=1) {
			if(roles[i].permissions) {
				permissionsArray.push(parseToJson(roles[i].permissions));
			}	
		}
		return permissionsArray;
	}
	return null;
};

/**
 * Returns an object for select option
 */
const dataToSelectOption = (value, valueKey, label, labelKey) => {
	if(value && valueKey && label && labelKey) {
		return { 
			[valueKey]: value,
			[labelKey]: label
		};
	} 
	return null;
};

/**
 * Group array of objects based on given property
 * @param array of objects, property 
 * returs - associative array
 */
const groupArrayByProperty = (arrayObjects, property) => {
	if(arrayObjects && Array.isArray(arrayObjects)) {
		return arrayObjects.reduce((acc, obj) => {
			const key = obj[property];
			if (!acc[key]) {
				acc[key] = [];
			}
			acc[key].push(obj);
			return acc;
		}, {});
	}
	return [];
};

export { 
	minutesToHours, hoursToMinutes, getMinutes, minutesToHourAndMinutes, 
	loadUserRole, loadRolePermissions, dataToSelectOption, groupArrayByProperty
};  // eslint-disable-line  import/prefer-default-export





// WEBPACK FOOTER //
// ./src/components/helpers/HelperFunctions.js